<svelte:options runes={false} />

<script>
  import { minorToMoney } from '../../api/invoices';
  import SectionHeading from './SectionHeading.svelte';
  import StatRow from './StatRow.svelte';

  export let invoice;
  export let reportedBits;
  export let detailReady = true;
  export let onOpenPayerPage;
</script>

{#if invoice}
  <SectionHeading eyebrow={invoice.invoiceReference || invoice.status} title={invoice.recipientLabel}>
    <svelte:fragment slot="trailing">
      <button type="button" on:click={onOpenPayerPage}>
        Open payer page
      </button>
    </svelte:fragment>
  </SectionHeading>

  <div class="stats">
    <StatRow label="Issued" value={invoice.issuedAt?.toLocaleDateString?.() || ''} />
    <StatRow label="Due" value={invoice.dueAt?.toLocaleDateString?.() || ''} />
    <!-- Not "reported/total" any more: U04 stopped publishing unreported bits to
         public readers, so the denominator was about to become a constant that
         read as though nothing was ever held back. -->
    <StatRow label="Reported items" value={detailReady ? String(reportedBits.length) : 'Loading…'} />
    <StatRow label="Asking rate" value="{minorToMoney(invoice.minHourlyRateMinor, invoice.currency)}/h" />
  </div>
{:else}
  <h2>No work has been reported yet</h2>
{/if}
